import { render, staticRenderFns } from "./EmpleadoChecador.vue?vue&type=template&id=2876937f"
import script from "./EmpleadoChecador.vue?vue&type=script&lang=js"
export * from "./EmpleadoChecador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports